import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Global from '../../store/global-selectors';
import { changePage } from '../../store/returns/grid/returns.grid.actions';
import { PagingControl } from '../../components/paging-control';

const mapStatesToProps = (state) => {
  return {
    page: Global.selectReturnsGridPage(state),
    pageSize: Global.selectReturnsGridPageSize(state),
    totalPages: Global.selectReturnsGridTotalPages(state),
    totalRecords: Global.selectReturnsGridTotalRecords(state),
    viewStartingCount: Global.selectReturnsGridViewStartingCount(state),
    viewEndingCount: Global.selectReturnsGridViewEndingCount(state),
    numberSelected: Global.selectSelectedReturnsCount(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onPageChange: bindActionCreators(changePage, dispatch),
  };
};

export const ReturnsGridPagingControlContainer = connect(mapStatesToProps, mapDispatchToProps, null, {
  pure: false,
})(PagingControl);
